import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.finalizeOnboardingPage.pageTitle',
    defaultMessage: 'Sessione terminata',
    description: 'Title of the page',
  },
  failTitle: {
    id: 'features.finalizeOnboardingPage.failTitle',
    defaultMessage: 'Ci dispiace.',
  },
  successTitle: {
    id: 'features.finalizeOnboardingPage.successTitle',
    defaultMessage: 'Fantastico!',
  },
  successSubtitle: {
    id: 'features.finalizeOnboardingPage.successSubtitle',
    defaultMessage:
      'Hai concluso la fase di riconoscimento, ora ti verrà chiesto di inserire una password da associare alla tua utenza MyAzimut.'

  },
  successSubtitle2: {
    id: 'features.finalizeOnboardingPage.successSubtitle2',
    defaultMessage:
    'Nei successivi tentativi di accesso all’area riservata MyAzimut dovrai utilizzare come Username l’email inserita durante la registrazione, insieme alla password che imposterai nella pagina successiva.',
  },
  successSubtitle3: {
    id: 'features.finalizeOnboardingPage.successSubtitle3',
    defaultMessage:
    'Se non imposti la password potrai farlo in un secondo momento dalla pagina di login, attraverso la funzionalità Recupera Credenziali.',
  },
  failSubtitle: {
    id: 'features.finalizeOnboardingPage.failSubtitle',
    defaultMessage:
      'Ci dispiace, non è stato possibile effettuare il processo di onboarding in self, ti invitiamo a contattare il tuo consulente finanziario per avviare una nuova pratica.',
  },
  buttonLabel: {
    id: 'features.finalizeOnboardingPage.buttonLabel',
    defaultMessage: 'AVANTI',
  }

});
